export default __webpack_public_path__ + "static/media/support-allied-martin-mundo.bc8c5b36.png";